"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _client = require("react-dom");
var _labeling = _interopRequireDefault(require("../../containers/labeling"));
var _adyenWeb = _interopRequireDefault(require("@adyen/adyen-web"));
var _createPaymentSession = _interopRequireDefault(require("../../api/Payment/createPaymentSession"));
var _useScriptHook = _interopRequireDefault(require("../../util/useScriptHook"));
var _paymentMethodHelper = require("../../util/paymentMethodHelper");
var _reactRedux = require("react-redux");
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _PaymentStyled = require("../Payment/PaymentStyled");
var _AdyenStyled = _interopRequireDefault(require("./AdyenStyled"));
var _eventDispatcher = _interopRequireWildcard(require("../../util/eventDispatcher"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _getAdyenConfig = require("./util/getAdyenConfig");
var _defaultAdyenTranslations = _interopRequireDefault(require("./util/defaultAdyenTranslations"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Adyen = function Adyen(_ref) {
  var _onSubmit = _ref.onSubmit,
    isMyAccount = _ref.isMyAccount,
    selectPaymentMethod = _ref.selectPaymentMethod,
    isPayPalAvailable = _ref.isPayPalAvailable,
    getDropIn = _ref.getDropIn,
    onAdditionalDetails = _ref.onAdditionalDetails,
    t = _ref.t;
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.order.order;
    }),
    discount = _useSelector.discount,
    totalPrice = _useSelector.totalPrice,
    offerId = _useSelector.offerId;
  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
      return state.publisherConfig;
    }),
    adyenConfiguration = _useSelector2.adyenConfiguration,
    publisherPaymentMethods = _useSelector2.paymentMethods,
    visiblePaymentMethods = _useSelector2.visiblePaymentMethods;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useSelector3 = (0, _reactRedux.useSelector)(function (state) {
      return state.paymentMethods;
    }),
    selectedPaymentMethod = _useSelector3.selectedPaymentMethod;
  var standardPaymentMethodsRef = (0, _react.useRef)(null);
  var bankPaymentMethodsRef = (0, _react.useRef)(null);
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    standardDropInInstance = _useState4[0],
    setStandardDropInInstance = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    bankDropInInstance = _useState6[0],
    setBankDropInInstance = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    standardPaymentSession = _useState8[0],
    setStandardPaymentSession = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    standardSessionError = _useState10[0],
    setStandardSessionError = _useState10[1];
  var _useState11 = (0, _react.useState)(null),
    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
    bankSessionError = _useState12[0],
    setBankSessionError = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
    noPaymentMethods = _useState14[0],
    setNoPaymentMethods = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
    shouldFadeOutStandardDropIn = _useState16[0],
    setShouldFadeOutStandardDropIn = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
    shouldFadeOutBankDropIn = _useState18[0],
    setShouldFadeOutBankDropIn = _useState18[1];
  var _useState19 = (0, _react.useState)(false),
    _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
    shouldHideStandardDropIn = _useState20[0],
    setShouldHideStandardDropIn = _useState20[1];
  var _useState21 = (0, _react.useState)(false),
    _useState22 = (0, _slicedToArray2.default)(_useState21, 2),
    shouldHideBankDropIn = _useState22[0],
    setShouldHideBankDropIn = _useState22[1];
  (0, _useScriptHook.default)('https://pay.google.com/gp/p/js/pay.js');
  var getBankCopy = function getBankCopy() {
    var isFree = totalPrice === 0;
    var isSubscription = (offerId === null || offerId === void 0 ? void 0 : offerId.charAt(0)) === 'S';
    if (isMyAccount || isFree && isSubscription) {
      return t('offer-bank-consent-copy.free-subscription', 'You accept the terms and conditions of this agreement and that your account will be charged €0.10 for authentication purposes. This amount will be refunded once the transaction is completed. And your account will be debited on a recurring basis for the full subscription amount.');
    }
    if (isSubscription) {
      return t('offer-bank-consent-copy.paid-subscription', 'You accept the terms and conditions of this agreement. Your account will be debited on a recurring basis for the full subscription amount.');
    }
    return t('offer-bank-consent-copy.paid-not-subscription', 'You accept the terms and conditions of this agreement.');
  };
  var addAdditionalCopyForBankPaymentMethods = function addAdditionalCopyForBankPaymentMethods(methodName) {
    var parentEl = document.querySelector(".adyen-checkout__payment-method--".concat(methodName));
    var checkbox = /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      className: "adyen-checkout__bank-checkbox checkbox-".concat(methodName),
      checked: false,
      onClickFn: function onClickFn(e, _, setIsChecked) {
        e.target.parentElement.classList.remove('adyen-checkout__bank-checkbox--error');
        setIsChecked(!e.target.checked);
      }
    }, getBankCopy());
    if (parentEl) {
      var details = parentEl.querySelector('.adyen-checkout__payment-method__details');
      var doesCheckboxExist = document.querySelector(".checkbox-".concat(methodName));
      if (!doesCheckboxExist) {
        var wrapper = document.createElement('div');
        wrapper.classList.add('checkbox-wrapper');
        _client.render(checkbox, wrapper);
        details.before(wrapper);
      }
    }
  };
  var showAdditionalText = function showAdditionalText() {
    if (bankPaymentMethodsRef !== null && bankPaymentMethodsRef !== void 0 && bankPaymentMethodsRef.current) {
      _paymentMethodHelper.bankPaymentMethods.forEach(function (method) {
        return addAdditionalCopyForBankPaymentMethods(method);
      });
    }
  };
  var onSelect = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref2) {
      var type;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            type = _ref2.type;
            return _context.abrupt("return", selectPaymentMethod(_paymentMethodHelper.bankPaymentMethodsMapper[type] || type));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSelect(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var mountStandardDropIn = function mountStandardDropIn(adyenCheckout) {
    if (standardPaymentMethodsRef !== null && standardPaymentMethodsRef !== void 0 && standardPaymentMethodsRef.current) {
      var dropin = adyenCheckout.create('dropin', {
        onSelect: onSelect,
        openFirstPaymentMethod: (adyenConfiguration === null || adyenConfiguration === void 0 ? void 0 : adyenConfiguration.openFirstPaymentMethod) == null ? !window.matchMedia('(max-width:991px)').matches : adyenConfiguration === null || adyenConfiguration === void 0 ? void 0 : adyenConfiguration.openFirstPaymentMethod,
        onReady: showAdditionalText
      });
      dropin.mount(standardPaymentMethodsRef.current);
      setStandardDropInInstance(dropin);
      getDropIn(dropin, _paymentMethodHelper.STANDARD_PAYMENT_METHODS);
    }
  };
  var mountBankDropIn = function mountBankDropIn(adyenCheckout) {
    if (bankPaymentMethodsRef !== null && bankPaymentMethodsRef !== void 0 && bankPaymentMethodsRef.current) {
      var dropin = adyenCheckout.create('dropin', {
        onSelect: onSelect,
        onReady: showAdditionalText,
        openFirstPaymentMethod: false
      });
      dropin.mount(bankPaymentMethodsRef.current);
      setBankDropInInstance(dropin);
      getDropIn(dropin, _paymentMethodHelper.BANK_PAYMENT_METHODS);
    }
  };
  var onError = function onError(_ref4) {
    var error = _ref4.error,
      fieldType = _ref4.fieldType;
    (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_ADYEN_ERROR, {
      error: error,
      fieldType: fieldType
    });
  };
  var createDropInInstance = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(_ref5, type) {
      var _paymentMethods$find, _paymentMethods$find2, _adyenConfiguration$p, _adyenConfiguration$p2, _adyenConfiguration$p3, _adyenConfiguration$p4;
      var id, sessionData, merchantName, amount, countryCode, paymentMethods, amountObj, applePayConfigurationObj, googlePayConfigurationObj, configuration, adyenCheckout;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            id = _ref5.id, sessionData = _ref5.sessionData, merchantName = _ref5.shopperStatement, amount = _ref5.amount, countryCode = _ref5.countryCode, paymentMethods = _ref5.paymentMethods;
            amountObj = {
              amount: amount,
              countryCode: countryCode
            };
            applePayConfigurationObj = paymentMethods && ((_paymentMethods$find = paymentMethods.find(function (item) {
              return item.type === 'applepay';
            })) === null || _paymentMethods$find === void 0 ? void 0 : _paymentMethods$find.configuration);
            googlePayConfigurationObj = paymentMethods && ((_paymentMethods$find2 = paymentMethods.find(function (item) {
              return item.type === 'googlepay';
            })) === null || _paymentMethods$find2 === void 0 ? void 0 : _paymentMethods$find2.configuration);
            configuration = {
              locale: (adyenConfiguration === null || adyenConfiguration === void 0 ? void 0 : adyenConfiguration.locale) || 'en-US',
              translations: _objectSpread(_objectSpread({}, _defaultAdyenTranslations.default), adyenConfiguration === null || adyenConfiguration === void 0 ? void 0 : adyenConfiguration.translations),
              environment: (0, _getAdyenConfig.getAdyenEnv)(),
              analytics: (adyenConfiguration === null || adyenConfiguration === void 0 ? void 0 : adyenConfiguration.analytics) || {
                enabled: true //  analytics data for Adyen
              },

              setStatusAutomatically: false,
              session: {
                id: id,
                sessionData: sessionData
              },
              clientKey: (0, _getAdyenConfig.getAdyenClientKey)(),
              onSubmit: function onSubmit(state, component) {
                var methodName = state.data.paymentMethod.type;
                if (_paymentMethodHelper.bankPaymentMethods.includes(methodName)) {
                  var checkbox = document.querySelector(".checkbox-".concat(methodName));
                  if (!checkbox.checked) {
                    checkbox.classList.add('adyen-checkout__bank-checkbox--error');
                    return false;
                  }
                }
                component.setStatus('loading');
                if (type === _paymentMethodHelper.BANK_PAYMENT_METHODS) {
                  setShouldFadeOutStandardDropIn(true);
                } else {
                  setShouldFadeOutBankDropIn(true);
                }
                return _onSubmit(state, component);
              },
              onActionHandled: function onActionHandled() {
                if (type === _paymentMethodHelper.BANK_PAYMENT_METHODS) {
                  setShouldHideStandardDropIn(true);
                } else {
                  setShouldHideBankDropIn(true);
                }
              },
              onAdditionalDetails: onAdditionalDetails,
              onError: onError,
              paymentMethodsConfiguration: {
                card: _objectSpread({
                  hasHolderName: true,
                  holderNameRequired: true
                }, adyenConfiguration === null || adyenConfiguration === void 0 ? void 0 : (_adyenConfiguration$p = adyenConfiguration.paymentMethodsConfiguration) === null || _adyenConfiguration$p === void 0 ? void 0 : _adyenConfiguration$p.card),
                applepay: _objectSpread(_objectSpread(_objectSpread({}, amountObj), applePayConfigurationObj && {
                  configuration: {
                    merchantName: merchantName,
                    merchantId: applePayConfigurationObj.merchantId
                  }
                }), adyenConfiguration === null || adyenConfiguration === void 0 ? void 0 : (_adyenConfiguration$p2 = adyenConfiguration.paymentMethodsConfiguration) === null || _adyenConfiguration$p2 === void 0 ? void 0 : _adyenConfiguration$p2.applePay),
                googlepay: _objectSpread(_objectSpread({
                  environment: (0, _getAdyenConfig.getGooglePayEnv)()
                }, googlePayConfigurationObj && {
                  configuration: {
                    merchantName: merchantName,
                    gatewayMerchantId: googlePayConfigurationObj.gatewayMerchantId,
                    merchantId: googlePayConfigurationObj.merchantId
                  }
                }), amountObj),
                ideal: _objectSpread({}, adyenConfiguration === null || adyenConfiguration === void 0 ? void 0 : (_adyenConfiguration$p3 = adyenConfiguration.paymentMethodsConfiguration) === null || _adyenConfiguration$p3 === void 0 ? void 0 : _adyenConfiguration$p3.ideal),
                bcmc: _objectSpread(_objectSpread({}, adyenConfiguration === null || adyenConfiguration === void 0 ? void 0 : (_adyenConfiguration$p4 = adyenConfiguration.paymentMethodsConfiguration) === null || _adyenConfiguration$p4 === void 0 ? void 0 : _adyenConfiguration$p4.bancontactCard), {}, {
                  hasHolderName: true,
                  holderNameRequired: true,
                  positionHolderNameOnTop: true
                })
              }
            };
            _context2.next = 7;
            return (0, _adyenWeb.default)(configuration);
          case 7:
            adyenCheckout = _context2.sent;
            if (!(type === _paymentMethodHelper.BANK_PAYMENT_METHODS)) {
              _context2.next = 12;
              break;
            }
            mountBankDropIn(adyenCheckout);
            setIsLoading(false);
            return _context2.abrupt("return");
          case 12:
            mountStandardDropIn(adyenCheckout);
            setIsLoading(false);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function createDropInInstance(_x2, _x3) {
      return _ref6.apply(this, arguments);
    };
  }();
  var createSession = /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(paymentMethodsType) {
      var response;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return (0, _createPaymentSession.default)(paymentMethodsType, visiblePaymentMethods, isMyAccount);
          case 3:
            response = _context3.sent;
            if (response !== null && response !== void 0 && response.id) {
              createDropInInstance(response, paymentMethodsType);
            }
            _context3.next = 11;
            break;
          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            if (paymentMethodsType === _paymentMethodHelper.BANK_PAYMENT_METHODS) {
              setBankSessionError(_context3.t0.message);
            } else {
              setStandardSessionError(_context3.t0.message);
            }
            setIsLoading(false);
          case 11:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 7]]);
    }));
    return function createSession(_x4) {
      return _ref7.apply(this, arguments);
    };
  }();
  var generateDropIns = function generateDropIns() {
    var availablePaymentMethods = (0, _paymentMethodHelper.getAvailablePaymentMethods)(publisherPaymentMethods, visiblePaymentMethods);
    if (!availablePaymentMethods.length) {
      setNoPaymentMethods(true);
      setIsLoading(false);
      return;
    }
    if (isMyAccount || totalPrice === 0) {
      var shouldCreateStandardPaymentSession = availablePaymentMethods.some(function (_ref8) {
        var methodName = _ref8.methodName;
        return !_paymentMethodHelper.bankPaymentMethods.includes(methodName);
      });
      if (shouldCreateStandardPaymentSession) {
        setStandardPaymentSession(true);
        createSession(_paymentMethodHelper.STANDARD_PAYMENT_METHODS);
      }
      var shouldCreateBankPaymentSession = availablePaymentMethods.some(function (_ref9) {
        var methodName = _ref9.methodName;
        return _paymentMethodHelper.bankPaymentMethods.includes(methodName);
      });
      if (shouldCreateBankPaymentSession) {
        createSession(_paymentMethodHelper.BANK_PAYMENT_METHODS);
      }
    } else {
      createSession();
    }
  };
  (0, _react.useEffect)(function () {
    generateDropIns();
    return function () {
      setStandardDropInInstance(null);
      setBankDropInInstance(null);
    };
  }, []);
  var closeBank = (0, _react.useCallback)(function () {
    if (bankDropInInstance) {
      bankDropInInstance.closeActivePaymentMethod();
    }
  }, [bankDropInInstance]);
  var closeStandard = (0, _react.useCallback)(function () {
    if (standardDropInInstance) {
      standardDropInInstance.closeActivePaymentMethod();
    }
  }, [standardDropInInstance]);
  (0, _react.useEffect)(function () {
    if (bankDropInInstance && standardDropInInstance) {
      standardPaymentMethodsRef.current.addEventListener('click', closeBank);
      bankPaymentMethodsRef.current.addEventListener('click', closeStandard);
    }
  }, [standardDropInInstance, bankDropInInstance]);
  (0, _react.useEffect)(function () {
    if (standardDropInInstance && discount !== null && discount !== void 0 && discount.applied) {
      // recreate Adyen Instance if coupon was applied
      bankPaymentMethodsRef.current.removeEventListener('click', closeStandard);
      standardPaymentMethodsRef.current.removeEventListener('click', closeBank);
      if (standardDropInInstance) {
        standardDropInInstance.unmount();
        setStandardDropInInstance(null);
        getDropIn(null, _paymentMethodHelper.STANDARD_PAYMENT_METHODS);
      }
      if (bankDropInInstance) {
        bankDropInInstance.unmount();
        setBankDropInInstance(null);
        getDropIn(null, _paymentMethodHelper.BANK_PAYMENT_METHODS);
      }
      setIsLoading(true);
      generateDropIns();
    }
  }, [discount.applied]);
  (0, _react.useEffect)(function () {
    if ((selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.methodName) === 'paypal') {
      if (standardDropInInstance) standardDropInInstance.closeActivePaymentMethod();
      if (bankDropInInstance) bankDropInInstance.closeActivePaymentMethod();
    }
  }, [selectedPaymentMethod]);
  if (noPaymentMethods) {
    return /*#__PURE__*/_react.default.createElement(_PaymentStyled.PaymentErrorStyled, null, t('Payment methods are not available'));
  }
  var shouldShowSessionError = standardSessionError && bankSessionError || bankSessionError && !standardPaymentSession;
  if (shouldShowSessionError && !isPayPalAvailable) {
    return /*#__PURE__*/_react.default.createElement(_PaymentStyled.PaymentErrorStyled, null, bankSessionError);
  }
  return /*#__PURE__*/_react.default.createElement(_AdyenStyled.default, {
    isMyAccount: true,
    isAdditionalPayment: isPayPalAvailable
  }, isLoading && /*#__PURE__*/_react.default.createElement(_Loader.default, null), /*#__PURE__*/_react.default.createElement("div", {
    ref: standardPaymentMethodsRef,
    style: _objectSpread(_objectSpread({}, shouldHideStandardDropIn && {
      display: 'none'
    }), shouldFadeOutStandardDropIn && {
      opacity: '0.2',
      pointerEvents: 'none'
    })
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: bankPaymentMethodsRef,
    style: _objectSpread(_objectSpread({}, shouldHideBankDropIn && {
      display: 'none'
    }), shouldFadeOutBankDropIn && {
      opacity: '0.2',
      pointerEvents: 'none'
    })
  }));
};
Adyen.propTypes = {
  onSubmit: _propTypes.default.func.isRequired,
  isMyAccount: _propTypes.default.bool,
  selectPaymentMethod: _propTypes.default.func.isRequired,
  isPayPalAvailable: _propTypes.default.bool.isRequired,
  getDropIn: _propTypes.default.func.isRequired,
  onAdditionalDetails: _propTypes.default.func.isRequired,
  t: _propTypes.default.func
};
Adyen.defaultProps = {
  isMyAccount: false,
  t: function t(k) {
    return k;
  }
};
var _default = (0, _reactI18next.withTranslation)()((0, _labeling.default)()(Adyen));
exports.default = _default;